import type { PokemonV2 } from '../../pokemon/pokemon';

// 努力値は0〜32の段階値に換算済み（レベル50の簡易式に合わせる）
// ivBase は個体値31/それ以外の差分を固定値で持つ
// レベル50で種族値、個体値、努力値を加味したHP実数値を計算する
export function calcRealValueHPStat(pokemon: PokemonV2) {
  const baseHp = pokemon.hp;
  const iv = 'individualValue' in pokemon ? pokemon.individualValue.hp : 31;
  const evStep = pokemon.effective_slider_step.hp;
  const ivBase = iv === 31 ? 75 : 60;
  return ivBase + baseHp + evStep;
}

export function calcRealValueAttackOffencePokemon(pokemon: PokemonV2) {
  const baseAttack = pokemon.attack;
  const iv = pokemon.individualValue.attack;
  const evStep = pokemon.effective_slider_step.attack;
  const ivBase = iv === 31 ? 20 : 5;
  let realValue = ivBase + baseAttack + evStep;
  realValue = Math.floor(realValue * pokemon.personality.attack);
  return realValue;
}

export function calcRealValueSpecialAttackOffencePokemon(pokemon: PokemonV2) {
  const baseSpecialAttack = pokemon.special_attack;
  const iv = pokemon.individualValue.special_attack;
  const evStep = pokemon.effective_slider_step.special_attack;
  const ivBase = iv === 31 ? 20 : 5;
  let realValue = ivBase + baseSpecialAttack + evStep;
  realValue = Math.floor(realValue * pokemon.personality.special_attack);
  return realValue;
}

export function calcRealValueDeffenceOffencePokemon(pokemon: PokemonV2) {
  const baseDefense = pokemon.defense;
  const iv = pokemon.individualValue.defense;
  const evStep = pokemon.effective_slider_step.defense;
  const ivBase = iv === 31 ? 20 : 5;
  let realValue = ivBase + baseDefense + evStep;
  realValue = Math.floor(realValue * pokemon.personality.defense);
  return realValue;
}

export function calcRealValueSpecialDeffenceOffencePokemon(pokemon: PokemonV2) {
  const baseSpecialDefense = pokemon.special_defense;
  const iv = pokemon.individualValue.special_defense;
  const evStep = pokemon.effective_slider_step.special_defense;
  const ivBase = iv === 31 ? 20 : 5;
  let realValue = ivBase + baseSpecialDefense + evStep;
  realValue = Math.floor(realValue * pokemon.personality.special_defense);
  return realValue;
}

export function calcRealValueAttackDefencePokemon(pokemon: PokemonV2) {
  const baseAttack = pokemon.attack;
  const iv = pokemon.individualValue.attack;
  const evStep = pokemon.effective_slider_step.attack;
  const ivBase = iv === 31 ? 20 : 5;
  let realValue = ivBase + baseAttack + evStep;
  realValue = Math.floor(realValue * pokemon.personality.attack);
  return realValue;
}

export function calcRealValueSpecialAttackDefencePokemon(pokemon: PokemonV2) {
  const baseSpecialAttack = pokemon.special_attack;
  const iv = pokemon.individualValue.special_attack;
  const evStep = pokemon.effective_slider_step.special_attack;
  const ivBase = iv === 31 ? 20 : 5;
  let realValue = ivBase + baseSpecialAttack + evStep;
  realValue = Math.floor(realValue * pokemon.personality.special_attack);
  return realValue;
}

export function calcRealValueDeffenceDefencePokemon(pokemon: PokemonV2) {
  const baseDefense = pokemon.defense;
  const iv = pokemon.individualValue.defense;
  const evStep = pokemon.effective_slider_step.defense;
  const ivBase = iv === 31 ? 20 : 5;
  let realValue = ivBase + baseDefense + evStep;
  realValue = Math.floor(realValue * pokemon.personality.defense);
  return realValue;
}

export function calcRealValueSpecialDeffenceDefencePokemon(pokemon: PokemonV2) {
  const baseSpecialDefense = pokemon.special_defense;
  const iv = pokemon.individualValue.special_defense;
  const evStep = pokemon.effective_slider_step.special_defense;
  const ivBase = iv === 31 ? 20 : 5;
  let realValue = ivBase + baseSpecialDefense + evStep;
  realValue = Math.floor(realValue * pokemon.personality.special_defense);
  return realValue;
}

export function calcRealValueSpeedOffencePokemon(pokemon: PokemonV2) {
  const baseSpeed = pokemon.speed;
  const iv = pokemon.individualValue.speed;
  const evStep = pokemon.effective_slider_step.speed;
  const ivBase = iv === 31 ? 20 : 5;
  let realValue = ivBase + baseSpeed + evStep;
  realValue = Math.floor(realValue * pokemon.personality.speed);
  return realValue;
}

export function calcRealValueSpeedDefencePokemon(pokemon: PokemonV2) {
  const baseSpeed = pokemon.speed;
  const iv = pokemon.individualValue.speed;
  const evStep = pokemon.effective_slider_step.speed;
  const ivBase = iv === 31 ? 20 : 5;
  let realValue = ivBase + baseSpeed + evStep;
  realValue = Math.floor(realValue * pokemon.personality.speed);
  return realValue;
}
